import './culture.scss';

import '@/utils/common.js';
import ScrollAnim from '@/utils/scroll-anim.js';
new ScrollAnim();
